
type SelectElementChoice = { id: string, name: string }


export const useYearChoices: () => SelectElementChoice[] = (): SelectElementChoice[] => {
    let choices: SelectElementChoice[] = [
        { id: String(-1), name: 'Before 1900' }
    ];
    let currentTime: Date = new Date()
    for (let i: number = 1900; i <= currentTime.getFullYear(); i++) {
        choices.push({ id: String(i), name: String(i) });
    }

    return choices;

}

export const useSocialList: () => SelectElementChoice[] = (): SelectElementChoice[] => {
    return [
        { id: "instagram", name: "Instagram" },
        { id: "linkedin", name: "LinkedIn" },
        { id: "facebook", name: "Facebook" },
        { id: "snapchat", name: "Snapchat" },
    ];
}

export const useJobRoles: () => SelectElementChoice[] = (): SelectElementChoice[] => {
    return [
        { id: "A Crisp Roll", name: "A Crisp Roll" },
        { id: "manager", name: "Manager" },
        { id: "director", name: "Director" }
    ];
}

export const useYesNo: () => { id: boolean, name: string }[] = (): { id: boolean, name: string }[] => {
    return [
        { id: false, name: 'No' },
        { id: true, name: 'Yes' }
    ];
}

export const useActiveStatus: () => SelectElementChoice[] = (): SelectElementChoice[] => {
    return [
        { id: 'inactive', name: 'Inactive' },
        { id: 'active', name: 'Active' }
    ];
}


function getRandomColor(): string {
    let letters: string = '0123456789ABCDEF';
    let color: string = '#';
    for (let i: number = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

const invertColor: (hexValue: any) => string = (hexValue: any): string => {
    let hex = hexValue.replace(/^#/, '');
    if (hex.length === 3) hex = hex.replace(/./g, '$&$&'); // Expand
    if (hex.length !== 6) throw new Error(`Invalid HEX color: ${hexValue}`);
    return `#${(0xFFFFFF ^ parseInt(hex, 16)).toString(16).padStart(6, '0')}`;
};


export const nokSoloOrCompanyOptions: SelectElementChoice[] = [
    { id: 'solo', name: 'Solo Customer' },
    { id: 'company', name: 'Company' },
];

export const settingsSections: { sectionTitle: string, path: string }[] = [
    {
        'sectionTitle': 'Companies House Settings',
        'path': 'companies/house',
    },
    {
        'sectionTitle': 'Stripe Settings',
        'path': 'subscriptions/subscriptions'
    },
    {
        'sectionTitle': 'SMTP Email Settings',
        'path': 'emails/mailgun'
    },
    {
        'sectionTitle': 'System Emails',
        'path': 'system/emails'
    },
    {
        'sectionTitle': 'System Defaults',
        'path': 'system/defaults'
    },
    {
        'sectionTitle': 'Nok Defaults',
        'path': 'nok/defaults'
    }
];

// A Nok email template's status. HQ-API's `NokEmailTemplate::STATUSES` allows only these two.
export const nokEmailTemplateStatuses: SelectElementChoice[] = [
    { id: 'active', name: 'Active' },
    { id: 'disabled', name: 'Disabled' },
];

export const nokStatus: SelectElementChoice[] = [
    { id: 'retired', name: 'Retired' },
    { id: 'testing', name: 'Testing' },
    { id: 'active', name: 'Active' },
];

export const nokMiniTagChoices: SelectElementChoice[] = [
    { id: 'bounce', name: 'Bounce' },
    { id: 'compliance', name: 'Compliance' },
    { id: 'crawl', name: 'Crawl' },
    { id: 'disclaimer', name: 'Disclaimer' },
    { id: 'finder', name: 'Finder' },
    { id: 'inventory', name: 'Inventory' },
    { id: 'privacy', name: 'Privacy' },
    { id: 'reply', name: 'Reply' },
    { id: 'response', name: 'Response' },
    { id: 'times', name: 'Times' }
];

export  const currency: SelectElementChoice[] = [
    { id: 'gbp', name: 'GBP' },
    { id: 'usd', name: 'USD' },
    { id: 'eur', name: 'EUR' },
];

export const frequency: SelectElementChoice[] = [
    { id: 'month', name: 'Monthly' },
    { id: 'year', name: 'Yearly' },
];

export const accountTypes: SelectElementChoice[] = [
    { id: 'personal', name: 'Personal' },
    { id: 'company', name: 'Company' },
]

export const accountStatus: SelectElementChoice[] = [
    { id: 'inactive', name: 'Inactive' },
    { id: 'new', name: 'New' },
    { id: 'trial', name: 'Trial' },
    { id: 'active', name: 'Active' },
    { id: 'closed', name: 'Closed' },
]

export const seatCounts: { id: number, name: string }[] = [
    { id: 3, name: '3' },
    { id: 5, name: '5' },
    { id: 10, name: '10' },
    { id: 15, name: '15' },
    { id: 20, name: '20' },
    { id: 30, name: '30' },
    { id: 50, name: '50+' },
];

export const pricingTiers: SelectElementChoice[] = [
    { id: 'free', name: 'Free' },
    { id: 'free_paid', name: 'Freemium' },
    { id: 'paid_only', name: 'Paid Only' },
];

export function convertCurrencyToSymbol(code: string): string {
    const currencies = {
        'gbp': '£',
        'usd': '$',
        'eur': '€'
    };
    return currencies[code] ?? code;
}

export const couponTypes: SelectElementChoice[] = [
    { id: 'fixed', name: 'Fixed Amount' },
    { id: 'percent', name: 'Percentage' },
];

export const couponDuration: SelectElementChoice[] = [
    { id: 'forever', name: 'Forever' },
    { id: 'once', name: 'Apply Once' },
    { id: 'repeating', name: 'Repeating' },
];

export const invoiceTypes: SelectElementChoice[] = [
    { id: 'subscription', name: 'Subscription' },
    { id: 'single', name: 'Single Charge' },
];

export const enterpriseRequestStatus: SelectElementChoice[] = [
    { id: 'new', name: 'New' },
    { id: 'first', name: 'First Contact' },
    { id: 'inactive', name: 'Inactive (No response)' },
    { id: 'fail', name: 'Failed To Convert' },
    { id: 'closed', name: 'New Contact Converted' },
]

export const emailFinderStatuses: SelectElementChoice[] = [
    { id: 'pending', name: 'Pending' },
    { id: 'queued', name: 'Queued' },
    { id: 'complete', name: 'Complete' },
    { id: 'running', name: 'Running' },
    { id: 'cancelled', name: 'Cancelled' },
]

export const emailFinderResultStatus: SelectElementChoice[] = [
    { id: 'new', name: 'New' },
    { id: 'existing', name: 'Existing' },
    { id: 'changed', name: 'Changed' },
    { id: 'new_contact', name: 'New Contact' },
]

export const contactTypes: { name: string, id: string }[] = [
    { name: 'Full-time', id: 'full-time' },
    { name: 'Part-time', id: 'part-time' },
    { name: 'Contractor', id: 'contractor' },
    { name: 'Temp', id: 'temp' },
]

/**
 * The states a Mystery Shopper or Compliance Sniffer run can be in, as the backend writes them.
 * The two products share one lifecycle, so they share one list.
 *
 * - 'draft' and 'queued': the customer handlers on save and activate, and the admin half on a
 *   scheduled send.
 * - 'running': the admin half on an immediate send, and `NokRescoreService` when a rescore reopens
 *   a run, which includes a customer rescoring their own.
 * - 'scoring': each product's `...MessageHandlerNokProcessor`. 'complete': `MSAndCSMiniScorer`.
 * - 'cancelled' and 'archive': the customer handlers, and the admin Cancel for 'cancelled'. Note
 *   'archive', not 'archived'.
 *
 * Mystery Shopper used to have a list of its own that offered 'pending', which is never written to
 * a run, and lacked 'scoring' and 'archive', so a run in either showed an empty dropdown (HQAPI-122).
 */
export const miniRunStatus: SelectElementChoice[] = [
    { id: 'draft', name: 'Draft' },
    { id: 'queued', name: 'Queued' },
    { id: 'running', name: 'Running' },
    { id: 'scoring', name: 'Scoring' },
    { id: 'complete', name: 'Complete' },
    { id: 'cancelled', name: 'Cancelled' },
    { id: 'archive', name: 'Archived' },
];

export const mysteryShopperStatus: SelectElementChoice[] = miniRunStatus;

export const mysteryShopperTypes: SelectElementChoice[] = [
    { id: 'admin', name: 'HQ Admin User' },
    { id: 'customer', name: 'NokNok Customer' },
]

export const mysteryShopperChannels: SelectElementChoice[] = [
    { id: 'email', name: 'Email' },
    { id: 'form', name: 'Form' },
]

export const mysteryShopperResultsStatus: SelectElementChoice[] = [
    { id: 'pending', name: 'Pending' },
    { id: 'active', name: 'Active' },
    // The four the backend actually sets while a result is in flight. Only 'pending', 'active'
    // and 'complete' were listed, so a result in any of the others rendered as a blank cell and
    // as an empty dropdown on its own screen.
    { id: 'running', name: 'Running' },
    { id: 'scoring', name: 'Scoring' },
    { id: 'out_of_time', name: 'Out of time' },
    { id: 'cancelled', name: 'Cancelled' },
    // Scoring stopped and has not been picked up again. It is not a state anyone should choose by
    // hand: it is set when a failure is recorded and cleared by a rescore.
    { id: 'failed', name: 'Failed' },
    { id: 'complete', name: 'Complete' },
];

export const complianceSnifferTypes: SelectElementChoice[] = [
    { id: 'admin', name: 'HQ Admin User' },
    { id: 'customer', name: 'NokNok Customer' },
];

/** The same lifecycle as a Mystery Shopper run: see `miniRunStatus`. */
export const complianceSnifferStatus: SelectElementChoice[] = miniRunStatus;

/**
 * How a sniff reaches its target. Email is the only one: `ComplianceSnifferHandler` is the sole
 * writer of `channel` and it writes 'email'. Mystery Shopper also offers 'form' and a sniff does
 * not, which is why this is its own list rather than a reuse of `mysteryShopperChannels`.
 */
export const complianceSnifferChannels: SelectElementChoice[] = [
    { id: 'email', name: 'Email' },
];

export const complianceSnifferResultsStatus: SelectElementChoice[] = [
    { id: 'pending', name: 'Pending' },
    { id: 'active', name: 'Active' },
    // The four the backend actually sets while a result is in flight. Only 'pending', 'active'
    // and 'complete' were listed, so a result in any of the others rendered as a blank cell and
    // as an empty dropdown on its own screen.
    { id: 'running', name: 'Running' },
    { id: 'scoring', name: 'Scoring' },
    { id: 'out_of_time', name: 'Out of time' },
    { id: 'cancelled', name: 'Cancelled' },
    // Scoring stopped and has not been picked up again. It is not a state anyone should choose by
    // hand: it is set when a failure is recorded and cleared by a rescore.
    { id: 'failed', name: 'Failed' },
    { id: 'complete', name: 'Complete' },
];

export const emailMessageDirectionOptions: SelectElementChoice[] = [
    { id: 'outbound', name: 'Outbound' },
    { id: 'inbound', name: 'Inbound' },
]

export const emailMessageStatuses: SelectElementChoice[] = [
    { id: 'new', name: 'New' },
    { id: 'opened', name: 'Opened' },
]

export const websiteStatuses: SelectElementChoice[] = [
    { id: 'verified', name: 'Verified' },
    { id: 'unverified', name: 'Unverified' },
]

export const nokStatuses: SelectElementChoice[] = [
    { id: 'testing', name: 'In Testing' },
    { id: 'active', name: 'Active' },
    { id: 'deprecated', name: 'Deprecated' },
];

export const nokTypes: SelectElementChoice[] = [
    { id: 'simple', name: 'Simple' },
    { id: 'complex', name: 'Complex' },
]

export const NerOptions: SelectElementChoice[] = [
    { id: 'PERSON',     name: 'PERSON — People and names' },
    { id: 'ORG',        name: 'ORG — Companies and organisations' },
    { id: 'GPE',        name: 'GPE — Countries, cities, states' },
    { id: 'LOC',        name: 'LOC — Non-GPE locations' },
    { id: 'PRODUCT',    name: 'PRODUCT — Objects, vehicles, foods' },
    { id: 'DATE',       name: 'DATE — Absolute or relative dates' },
    { id: 'TIME',       name: 'TIME — Times smaller than a day' },
    { id: 'MONEY',      name: 'MONEY — Monetary values' },
    { id: 'QUANTITY',   name: 'QUANTITY — Measurements' },
    { id: 'PERCENT',    name: 'PERCENT — Percentage values' },
    { id: 'FAC',        name: 'FAC — Buildings, airports, highways' },
    { id: 'EVENT',      name: 'EVENT — Named events' },
    { id: 'WORK_OF_ART',name: 'WORK_OF_ART — Titles of works' },
    { id: 'LAW',        name: 'LAW — Named legal documents' },
];

export const nokTestTypes: SelectElementChoice[] = [
    { id: 'nlp', name: 'Naturally Processing Language' },
    { id: 'string_in_string', name: 'Target contains a value' },
    { id: 'regex', name: 'Regex' },
    { id: 'time', name: 'Time' },
    { id: 'validate', name: 'Validate' },
    { id: 'search', name: 'Search By' },
    { id: 'multi_step', name: 'Multi Step' },
    { id: 'counter', name: 'Count Elements or Characters' },
    { id: 'ask_ai', name: 'Ask AI' },
    // { id: 'customer_provided', name: 'Customer Provided' }
]

export const nokLocations: SelectElementChoice[] = [
    { id: 'headers', name: 'Headers' },
    { id: 'subject', name: 'Subject' },
    { id: 'first_line', name: 'First Line of Body Plain' },
    { id: 'body_plain', name: 'Body Plain' },
    { id: 'body_html', name: 'Body HTML' },
    { id: 'signature', name: 'Signature' },
    { id: 'footer', name: 'Footer' },
    { id: 'domain', name: 'Domain Check' }
];

export const nokSearchTypes: SelectElementChoice[] = [
    { id: 'tags', name: 'HTML Tags' },
    { id: 'string', name: 'String' },
    { id: 'regex', name: 'Regex' },
];

export const nokScoringTypes: SelectElementChoice[] = [
    { id: 'boolean',              name: 'Boolean — two outcome scores' },
    { id: 'scaled_boolean',       name: 'Scaled Boolean — three outcome scores' },
    { id: 'banded',               name: 'Banded — value falls in a range' },
    { id: 'accumulated',          name: 'Accumulated — score per occurrence' },
    { id: 'threshold_accumulated', name: 'Threshold Accumulated — score above a minimum count' },
    { id: 'single_value', name: 'Single Value — single score' }
];

export const nokCountingTypes: SelectElementChoice[] = [
    { id: 'character', name: 'Character' },
    { id: 'characters', name: 'Total Characters' },
    { id: 'words', name: 'Total Words' },
];

export const nokScoringRangeOptions: SelectElementChoice[] = [
    { id: 'greater_than', name: 'Result greater than' },
    { id: 'less_than', name: 'Result less than' },
    { id: 'equal_to', name: 'Result equal to' },
    { id: 'between', name: 'Result between' },
    { id: 'not_equal_to', name: 'Result not equal to' },
    { id: 'greater_than_or_equal_to', name: 'Result greater than or equal to' },
    { id: 'less_than_or_equal_to', name: 'Result less than or equal to' },
];

export const nokEmailLocations: SelectElementChoice[] = [
    { id: 'first_response', name: 'First Response' },
    { id: 'first_human_response', name: 'First Human Response' },
    { id: 'last_response', name: 'Last Response' },
    { id: 'enquiry_email', name: 'Enquiry Email' },
    { id: 'enquiry_and_first_response', name: 'Enquiry and First Response' },
    { id: 'enquiry_and_first_human_response', name: 'Enquiry and First Human Response' },
    { id: 'enquiry_and_last_response', name: 'Enquiry and Last Response' },
];

export const nokNLPTypes: SelectElementChoice[] = [
    { id: 'keyword_echo',            name: 'Keyword Echo' },
    { id: 'sentence_variance',       name: 'Sentence Length Variance' },
    { id: 'type_token_ratio',        name: 'Type to Token Ratio' },
    { id: 'response_length_ratio',   name: 'Response Length Ratio' },
    { id: 'subject_overlap',         name: 'Subject Overlap' },
    { id: 'semantic_similarity',     name: 'Semantic Similarity' },
    { id: 'named_entity',            name: 'Named Entity Detection' },
    { id: 'pos_tag_match',           name: 'POS Tag Match' },
    { id: 'question_resolution',     name: 'Question Resolution' },
    { id: 'concrete_unit_detection', name: 'Concrete Unit Detection' },
    { id: 'name_in_greeting',        name: 'Name in Greeting' },
    { id: 'entity_proximity', name: 'Entity Proximity — entity within range of phrase match' },
    { id: 'core_question_answered',  name: 'Core Question Answered' },
];

export const nopNLPOSTypes: SelectElementChoice[] = [
    { id: 'ADV',   name: 'ADV — Adverb' },
    { id: 'ADJ',   name: 'ADJ — Adjective' },
    { id: 'NOUN',  name: 'NOUN — Noun' },
    { id: 'PROPN', name: 'PROPN — Proper noun' },
    { id: 'VERB',  name: 'VERB — Verb' },
    { id: 'AUX',   name: 'AUX — Auxiliary verb' },
    { id: 'INTJ',  name: 'INTJ — Interjection' },
];

export const nokConcreteUnitCheckTypes: SelectElementChoice[] = [
    { id: 'numeric_token',        name: 'Numeric token' },
    { id: 'currency_token',       name: 'Currency token' },
    { id: 'named_entity',         name: 'Named entity' },
    { id: 'definitive_statement', name: 'Definitive statement' },
];

export const nokCustomerDataPoints: SelectElementChoice[] = [
    { id: 'email_address', name: 'Email Address' },
    { id: 'first_name', name: 'First Name' },
    { id: 'last_name', name: 'Last Name' },
    { id: 'phone_number', name: 'Phone Number' },
    { id: 'company_name', name: 'Company Name' },
    { id: 'company_number', name: 'Company Number' },
    { id: 'company_address', name: 'Company Address' },
    { id: 'privacy_policy', name: 'Privacy Policy' },
    { id: 'custom_value', name: 'Custom Value (Requests the customer provide a value)' },
    { id: 'custom_values', name: 'Multiple Custom Value (Requests the customer provide a value)' },
];

export const validateHeaderOptions: SelectElementChoice[] = [
    { id: 'dkim', name: 'DKIM' },
    { id: 'spf', name: 'SPF'},
    { id: 'dmarc', name: 'DMARC' },
    { id: 'mx', name: 'MX' },
];

export const nokTimeOptions: SelectElementChoice[] = [
    { id: 'difference', name: 'Difference (in hours)' },
    { id: 'difference_minutes', name: 'Difference (in minutes)' },
    { id: 'is_before', name: 'Is Before' },
    { id: 'is_after', name: 'Is After' },
    { id: 'less_than', name: 'Less Than Hours' },
    { id: 'greater_than', name: 'Greater Than Hours' },
];

export const nokMultiStepOptions: SelectElementChoice[] = [
    { id: 'extract', name: 'Extract' },
    { id: 'filter', name: 'Filter — reduce a list by condition' },
    { id: 'regex', name: 'Regex' },
    { id: 'phrase_match', name: 'Phrase Match' },
    { id: 'nlp', name: 'NLP'},
    { id: 'spelling_grammar', name: 'Spelling & Grammar' }
];

export const nokMultiStepExtractionTypes: SelectElementChoice[] = [
    { id: 'strip_quoted_content',       name: 'Strip quoted / thread content' },
    // { id: 'extract_signature_block',    name: 'Extract signature block' },
    // { id: 'extract_body_only',          name: 'Extract body only' },
    { id: 'extract_opening_region',     name: 'Extract opening / greeting region' },
    { id: 'extract_question_sentences', name: 'Extract question sentences' },
    { id: 'extract_progression_sentences', name: 'Extract progression sentences' },
    { id: 'detect_sign_off',            name: 'Detect sign-off position' },
    { id: 'detect_phone_numbers',       name: 'Detect phone numbers' },
];

export const nokExtractionFilterOptions: SelectElementChoice[] = [
    { id: 'filter_generic_phrases',     name: 'Filter generic phrases' },
    { id: 'filter_by_entity_overlap',   name: 'Filter by entity overlap' },
    { id: 'filter_by_similarity',       name: 'Filter by similarity' },
    { id: 'filter_by_executable_pattern', name: 'Filter by executable pattern' },
];

export const nokStepPassConditions: SelectElementChoice[] = [
    { id: 'not_empty',       name: 'Not empty' },
    { id: 'match',           name: 'Match found' },
    { id: 'no_match',        name: 'No match found' },
    { id: 'any_match',       name: 'Any match found' },
    { id: 'above_threshold', name: 'Above threshold' },
    { id: 'below_threshold', name: 'Below threshold' },
];

export const nokConcreteEntityTypes: SelectElementChoice[] = [
    { id: 'date', name: 'Date' },
    { id: 'time', name: 'Time' },
    { id: 'money', name: 'Money' },
    { id: 'quantity', name: 'Quantity' },
    { id: 'percent', name: 'Percent' },
    { id: 'product', name: 'Product' },
    { id: 'org', name: 'Organization' },
    { id: 'person', name: 'Person' },
    { id: 'gpe', name: 'Geopolitical entity' },
];

export const nokSpellingGrammarOptions: SelectElementChoice[] = [
    { id: 'spelling', name: 'Spelling' },
    { id: 'grammar', name: 'Grammar' },
    { id: 'typos', name: 'Typos' },
    { id: 'punctuation', name: 'Punctuation' },
    { id: 'typograhpy', name: 'Typography' },
];

export const nokAiModels: SelectElementChoice[] = [
    { id: 'chatgpt-gpt-5', name: 'ChatGPT GPT-5' },
    { id: 'chatgpt-gpt-5-mini', name: 'ChatGPT GPT-5-mini' },
    { id: 'chatgpt-gpt-5-nano', name: 'ChatGPT GPT-5-nano' },
    { id: 'mistral-small', name: 'Mistral Small' },
    { id: 'mistral-medium', name: 'Mistral Medium' },
    { id: 'mistral-large', name: 'Mistral Large' },
    { id: 'mistral-zai-glm-5-2', name: 'Mistral - GLM 5.2' },
    { id: 'claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5' },
    { id: 'claude-sonnet-4-6', name: 'Claude Sonnet 4.6' },
    { id: 'claude-sonnet-5', name: 'Claude Sonnet 5' },
    { id: 'claude-opus-4-8', name: 'Claude Opus 4.8' },
    { id: 'ollama-qwen3.5:397b-cloud', name: 'Ollama - Qwen 3.5 397B Cloud' }
];

/**
 * What the assistant panel offers, and the short name each one wears in its header.
 *
 * Mistral only, GLM included because Mistral is who serves and bills it. That is the user's call
 * (2026-09-09) and it is also what keeps this honest: every entry here goes through one provider
 * and one API key, so choosing between them changes the price and nothing else.
 *
 * Derived from `nokAiModels` rather than written out again, so a Mistral model added there appears
 * here too and cannot arrive with a selector that differs by a character. **Daive keeps its own
 * copy in `CHAT_MODELS`** and clamps whatever the browser sends against it, because this list only
 * decides what the menu offers.
 *
 * The short name is what the header shows. A header is not the place for "Mistral - GLM 5.2", and
 * the menu carries the full name for anyone who wants it.
 */
export const daiveChatModelShortNames: Record<string, string> = {
    'mistral-small': 'Small',
    'mistral-medium': 'Medium',
    'mistral-large': 'Large',
    'mistral-zai-glm-5-2': 'GLM',
};

export const daiveChatModels: SelectElementChoice[] = nokAiModels.filter(
    (model: SelectElementChoice): boolean => String(model.id).startsWith('mistral-')
);

/**
 * What the panel opens on before anyone has chosen.
 *
 * The cheapest of the four by an order of magnitude: US$0.15 per million input tokens against
 * Mistral Medium's US$1.50, and the assistant's bill is almost entirely input. Chosen by the user
 * on 2026-09-09 after the cost cards made the difference visible. **Must match `CHAT_MODEL` in
 * Daive's `chat_bot.py`**, which is what answers when a message arrives naming nothing.
 */
export const defaultDaiveChatModel: string = 'mistral-small';

export const smtpZones: { id: string, name: string }[] = [
    { id: 'EU', name: 'European servers' },
    { id: 'US', name: 'USA servers' },
];

export const genders: { id: string, name: string }[] = [
    { id: 'male', name: 'Male' },
    { id: 'female', name: 'Female' },
    { id: 'other', name: 'Other' },
];

// A persona's age band. Mirrors `NokPersona::AGE_RANGES` in HQ-API; change both together.
export const nokPersonaAgeRanges: { id: string, name: string }[] = [
    { id: '18-24', name: '18 to 24' },
    { id: '25-34', name: '25 to 34' },
    { id: '35-44', name: '35 to 44' },
    { id: '45-54', name: '45 to 54' },
    { id: '55-64', name: '55 to 64' },
    { id: '65+', name: '65 and over' },
];

export const miniGradeTypes: { id: string, name: string }[] = [
    { id: 'simple', name: 'Simple' },
    { id: 'complex', name: 'Complex' },
];

export const miniGradeMiniCodes: { id: string, name: string }[] = [
    { id: 'ms', name: 'Mystery Shopper' },
    { id: 'cs', name: 'Compliance Sniffer' },
];